import { Icon, IconNames, IconColor } from '../Icon';

interface AbsenceTypeIconProps {
  variant?:
    | 'vacation'
    | 'maternity_leave'
    | 'student_leave'
    | 'business_trip'
    | 'sick_leave';
  color?: IconColor;
}

export const AbsenceTypeIcon = ({ variant, color }: AbsenceTypeIconProps) => {
  let iconName: IconNames;

  switch (variant) {
    case 'vacation':
      iconName = 'vkhrtek_vacation';
      break;
    case 'maternity_leave':
      iconName = 'vkhrtek_maternity_leave';
      break;
    case 'student_leave':
      iconName = 'education_outline';
      break;
    case 'business_trip':
      iconName = 'plane_outline';
      break;
    case 'sick_leave':
      iconName = 'vkhrtek_medical';
      break;
    default:
      iconName = 'calendar_outline';
  }

  return <Icon name={iconName} size="14" color={color} />;
};
